import React from "react"
//import I18n from "i18n-js/index.js.erb"

class SeasonalRate extends React.Component {

	constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
	}

	render() {
		return (
      <div className="item" key={this.props.rate.id}>
        <label>
          <input
            type="checkbox"
            value={this.props.rate.id}
            defaultChecked={this.props.isChecked(this.props.rate.id)}
            onChange={this.onChange}
          />
          {this.props.rate.status == "disabled" 
          ? <div style={{color: 'grey', display: "inline"}}>
              <i>{this.props.rate.code + ': ' + this.props.rate.name + ' (' + (this.props.rate.billing_policy_name || I18n.t('na')) + ') '}</i>
              <span className="ss ss-alert" title={I18n.t('status_is_disabled')}></span> 
            </div>    
          : this.props.rate.code + ': ' + this.props.rate.name + ' (' + (this.props.rate.billing_policy_name || I18n.t('na')) + ')'
          }
    
        </label>
      </div>
		)
  }

  onChange(event) {
    var seasonal_rate = {
      id: this.props.seasonal_rate.id,
      rate_id: event.target.value,
      season_id: this.props.seasonal_rate.season_id,
      status: 'disabled'
    }
    if(event.target.checked) seasonal_rate.status = 'enabled'
    this.props.selectOne(seasonal_rate)
  }

}

export default SeasonalRate
